export default __webpack_public_path__ + "static/media/Support.9ea8b801.svg";